import { Layout, Space, Row, Col } from "antd";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ModalOfferImg from "./ModalOfferImg";
import ObjectGallery from "./ObjectGallery";
import { useAppSelector } from "../../../../app/hooks";
import BuildParam from "./BuildParam";
import { getDate, getSI } from "../../../functions";
import ContactButtons from "../../ContactButtons";
import ApartParam from "./ApartParam";


const Object: React.FC = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { id } = useParams();
    const stateObj = useAppSelector(state => state.objects.objects);
    const obj = stateObj.find((card) => card.id === id);
    const selectId = useAppSelector(state => state.setting.selection);
    
    function openModal() {
        document.body.style.overflow = "hidden";
        setShowModal(true);
    }

    if (obj) {
        const updateDate = obj.values['63'].value ? obj.values['63'].value : 'дата';

        const objectCity = obj.values['55'].value.length ? obj.values['55'].value[0].recordValues['10'][0].recordTitle : 'Город';
        const objectCountry = obj.values['55'].value.length ? obj.values['55'].value[0].recordValues['36'][0].recordTitle : 'Страна';
        //const objectSquare =  obj.values['39'].value ? `${obj.values['39'].value}` : 'метраж';
        const distanceToSea = obj.values['55'].value.length ? obj.values['55'].value[0].recordValues['24'] : '0';
        const distanceToCenter = obj.values['55'].value.length ? obj.values['55'].value[0].recordValues['21'] : '0';
        
        // единица измерения расстояний из параметров здания(метры, футы)
        const buildMeasurementSystem = getSI(obj.values['55'].value.length ? obj.values['55'].value[0].recordValues['46'][0] : '0');
        // единица измерения из параметров квартиры
       // const apartMeasurementSystem = obj.values['78'].value.length ? getSI(obj.values['78'].value[0]) : '';
        const complexInfrastructire = obj.values['55'].value.length ? obj.values['55'].value[0].recordValues['30'].map((item: any) => item.recordTitle) : [];
    
        
        return (
            <Layout className="object">
                {showModal ? <ModalOfferImg setShowModal={setShowModal}/> : <></>}
                <div onClick={openModal}>
                    <ObjectGallery {...obj}/>
                </div>
                <ContactButtons selectId={selectId ? selectId : ''} objId={obj.id}/>
                <Space direction="vertical" className="object-params">
                    <div className="update_date">
                        <span>Обновлено: </span>
                        <span>
                            {getDate(updateDate, 'day')}
                        </span>
                    </div>
                    <div className="location param">
                        <h3>Местонахождение</h3>
                        <Row>
                            <Col xs={24} sm={24} md={12} >
                                <span>Страна:</span>
                                {objectCountry}
                            </Col>
                            <Col xs={24} sm={24} md={12} >
                                <span>Город:</span>
                                {objectCity}
                            </Col>
                            <Col xs={24} sm={24} md={12} >
                                <span>Расстояние до моря:</span>
                                {distanceToSea}
                                <span>{buildMeasurementSystem}</span>
                            </Col>
                            <Col xs={24} sm={24} md={12} >
                                <span>Расстояние до центра:</span>
                                {distanceToCenter}
                                <span>{buildMeasurementSystem}</span>
                            </Col>
                        </Row>        
                    </div>

                    <div className="apart param">
                        <h3>Параметры квартиры</h3>
                        <ApartParam {...obj}/>
                    </div>

                    <div className="build param">
                        <h3>Параметры здания</h3>
                        <BuildParam {...obj}/>
                    </div>

                    <div className="description param">
                        <h3>Описание</h3>
                        <Row>
                            <Col span={24} className="summary">
                                <p>
                                    {obj.values['64'].value ? obj.values['64'].value : 'текст'}
                                </p>
                                {/* <span className="readmore">Узнать больше</span> */}
                            </Col>
                        </Row>
                    </div>
                    <div className="additional param">
                            <h3>Инфраструктура на территории жилого комплекса</h3>
                            <Row>
                               {complexInfrastructire.length ? complexInfrastructire.map((item: string, index: number) => (
                                    <Col xs={24} sm={12} xl={8}  className="param-add" key={index}>
                                        {item}
                                    </Col>
                               ))
                               : ''
                            }
                            </Row>
                        </div>
                </Space>
            </Layout>
        )
    } else {
        return (
            <div>Упс, не найдено</div>
        )
    }
    
}

export default Object;